
import { post, get } from '../components/api'

export const getInventoryPrice =  (inventoryId, quantity = 1 , code, requestWht, useCredit) => {
  const data =  post(`/products/${inventoryId}/get_inventory_order_summary`,  {
    code, request_for_wht: requestWht, quantity, use_credit: useCredit
  })

  return data
}